module.exports = __webpack_public_path__ + "media/images/ic-logo-barra-preta-145c8f25f461bea61cdd8ab1532d241f.svg";